import { useState } from 'react';
import { useSelector } from 'react-redux';
import Icons from '../../../assets/images';
import { RootState } from '../../../redux/store';
import Api from '../../../utils/api';
import Toaster from '../../Toaster/Index';
import { Label, LeftPanel } from '../../Wrappers';
import { sendAmplitudeEvents, updatePluginList } from '../../../utils/helper';
import { EventNames } from '../../../utils/events';

export default function DevRev() {
    const sideBarObject: any = useSelector(
        (state: RootState) => state.config.sideBarObject
    );
    const [isLoading, setIsLoading] = useState(false);
    const [url, setUrl] = useState('');
    const [token, setToken] = useState('');
    const [errors, setErrors] = useState({});

    const install = async (e: React.ChangeEvent<any>) => {
        e.preventDefault();
        setIsLoading(true);
        setErrors({});
        sendAmplitudeEvents(EventNames.INT_CLICK_INSTALL, {
            category: sideBarObject.category,
            plugin_name: sideBarObject.name,
        });
        try {
            const res = await Api.installApi.commonInstall(sideBarObject.code, {
                url,
                token,
            });
            if (res.message) {
                Toaster.success(res.message);
            }
            await updatePluginList();
            setIsLoading(false);
        } catch (err: any) {
            setIsLoading(false);
            if (err.response.data.errors) {
                setErrors(err.response.data.errors);
            } else {
                Toaster.error(err.response.data.message);
            }
        }
    };
    return (
        <LeftPanel>
            <form
                action=''
                className='flex flex-col space-y-4'
                id='form1'
                onSubmit={install}
            >
                <div className='flex flex-col space-y-2'>
                    <Label>DevOrg URL</Label>
                    <div className='flex border-1  border-gray-300 rounded-sm'>
                        <input
                            type='text'
                            aria-label='InputText'
                            id='host'
                            className='placeholder-stone-500 w-80 focus:outline-none focus:border-px h-8 px-2'
                            placeholder='DevOrg URL'
                            value={url}
                            onChange={(e) => setUrl(e.target.value)}
                            required
                        />
                    </div>
                    {(errors as any).url && (
                        <small className='w-full h-2.5 text-[10px] text-red-600'>
                            {(errors as any).url && (errors as any).url[0]}
                        </small>
                    )}
                </div>
                <div className='flex flex-col space-y-2'>
                    <Label>DevRev Personal Access Token</Label>
                    <div className='flex border-1  border-gray-300 rounded-sm'>
                        <input
                            type='password'
                            aria-label='Password'
                            id='password'
                            className='placeholder-stone-500 w-80 focus:outline-none focus:border-px h-8 px-2'
                            placeholder='DevRev Personal Access Token'
                            onChange={(e) => setToken(e.target.value)}
                            value={token}
                            required
                        />
                    </div>
                    {(errors as any).token && (
                        <small className='w-full h-2.5 text-[10px] text-red-600'>
                            {(errors as any).token && (errors as any).token[0]}
                        </small>
                    )}
                </div>
                <button
                    type='submit'
                    form='form1'
                    className='py-1.5 left-0 bg-neutral-900 px-3 self-start rounded-sm hover:bg-neutral-800 text-white flex items-center'
                >
                    {isLoading && (
                        <img
                            width='14px'
                            src={Icons.loaderGif}
                            alt='loader'
                            className='mr-1'
                        />
                    )}
                    Install
                </button>
            </form>
        </LeftPanel>
    );
}
